import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import standardMetricsIcon from '../../assets/standardMetrics.png';
import additionalMetricsIcon from '../../assets/additionalMetrics.png';
import { SadFolderIllustration } from '../emptyStateIllustrations/EmptyStateIllustrations';
import { MetricCardsSkeletonLoader } from '../metricCardsSkeletonLoader/MetricCardsSkeletonLoader';
import '../../pages/metricdashboard/MetricDashboard.scss';
import {
    useGetDailyMetricsSummaryExportQuery,
    useGetDailyMetricsSummaryQuery,
    // useGetDailyMetricsTableDetailsQuery,
    useGetEmployeeMetricAllPayoutsQuery,
    useGetEmployeeMetricPayoutStatusQuery,
    useGetEmployeeMetricStatusQuery,
    useGetEmpMonthlyMetricAttainmentQuery,
    useGetEmpPayoutLevelMetricRatesQuery,
    useGetMonthlyMetricHistoryQuery,
    useGetMonthlyMetricsSummaryQuery,
} from '../../pages/metricdashboard/metricDashboardSlice';
import { monthNames } from '../../utils/typeConstants';
// import { DateTemplate } from '../dateTemplate/DateTemplate';
import { MetricGreetingCard } from '../metricGreetingCard/MetricGreetingCard';
import { MetricPayoutTable } from '../metricPayoutTable/MetricPayoutTable';
import { MetricProgress } from '../metricProgress/metricProgress';
import { MyDailyMetricsTable } from '../myDailyMetricsTable/MyDailyMetricsTable';
import { PayoutCalculator } from '../payoutCalculator/PayoutCalculator';
import {
    useGetAgentMetricDiscussionsQuery,
    useGetAgentNonMetricDiscussionsQuery,
} from '../../features/coaching/coachingSlice';
import {
    getFilteredDataByMetricName,
    groupMetricDataByMonth,
    groupNonMetricDataByMonth,
} from '../agentDiscussionsPlot/dataGrouping';
import AgentDiscussionsPlot from '../agentDiscussionsPlot/AgentDiscussionsPlot';
import { MANAGERDASHBOARD } from '../../constants';
import {GradientDefs} from '../metricMonthlySummaryCard/GradientDefs';
import NonPayoutMetricsPanel from '../nonPayoutMetricsPanel/NonPayoutMetricsPanel';
import StandardMetricsPanel from '../standardMetricsPanel/StandardMetricsPanel';
import MetricAttainmentPayoutCalculator from '../metricAttainmentPayoutCalculator/MetricAttainmentPayoutCalculator';

type metricProps = {
    empName: string;
    scorecardAgentsData: any;
    scorecardVersionId: number;
    inputYear: number;
    inputMonth: number;
};
// eslint-disable-next-line max-statements
export const EDSMyMetricTab = ({
    empName,
    scorecardAgentsData,
    scorecardVersionId,
    inputYear,
    inputMonth
}: metricProps) => {
    const { eid, scid, tldate } = useParams();
    const [employeeName, setEmployeeName] = useState(empName);
    const [fullemployeeName, setFullEmployeeName] = useState('');
    const [scorecardVersion, setScorecardVersion] = useState(0);
    const [agentnumber, setAgentNumber] = useState<any>();
    const [inputmonth, setMonth] = useState(new Date().getMonth() + 1);
    const [inputyear, setYear] = useState(new Date().getFullYear());
    const [exportData, setExportData] = useState<any>([]);
    const agentDisable = false;
    const [listOfUsersMetrics, setListOfUsersMetrics] = useState<Employee>([{ name: '', id: '' }]);
    const [selectedMetricName, setSelectedMetricName] = useState('');
    const [agentNonMetricDiscussionsData, setAgentNonMetricDiscussionsData] = useState<any>();
    const [agentMetricDiscussionsData, setAgentMetricDiscussionsData] = useState<any>();
    const [selectedMetricColorIndex, setSelectedMetricColorIndex] = useState(0);
    const [activeTab, setActiveTab] = useState<'standard' | 'additional'>('standard');

    const location = useLocation();

    useEffect(() => {
        setYear(inputYear);
        setMonth(inputMonth);
        setScorecardVersion(scorecardVersionId);
    }, [inputYear, inputMonth, scorecardVersionId]);

    const {
        data: edsMetricStatusData,
        isFetching: isMetricStatusFetching,
    } = useGetEmployeeMetricStatusQuery(
        {
            /* employeenumber: agentnumber, */
            employeenumber: parseInt(agentnumber, 10),
            year: inputyear,
            month: inputmonth,
            scorecardRoleId: 1,
        },
        { skip: !agentnumber }
    );
    const { data: edsMetricPayoutStatusData, isFetching: isPayoutStatusFetching } = useGetEmployeeMetricPayoutStatusQuery(
        {
            /* employeenumber: agentnumber, */
            employeenumber: parseInt(agentnumber, 10),
            year: inputyear,
            month: inputmonth,
        },
        { skip: !agentnumber }
    );
    const { data: edsMonthlyMetricsData, isFetching: isMonthlyMetricsFetching } = useGetMonthlyMetricsSummaryQuery(
        {
            employeenumber: parseInt(agentnumber, 10),
            year: inputyear,
            month: inputmonth,
            scorecardVersionId: scorecardVersion,
            scorecardRoleId: 1,
        },
        {
            skip: !edsMetricStatusData || edsMetricStatusData?.data.length === 0 || !agentnumber,
        }
    );
    const { data: monthlyMetricAttainmentData, isFetching: isMonthlyAttainmentFetching } = useGetEmpMonthlyMetricAttainmentQuery(
        {
            employeenumber: agentnumber?.toString(),
            year: inputyear,
            month: inputmonth,
            scorecardVersionId: scorecardVersion,
        },
        { skip: !agentnumber || !inputyear || !inputmonth || !scorecardVersion }
    );

    const { data: empPayoutLevelMetricRatesData, isFetching: isPayoutRatesFetching } = useGetEmpPayoutLevelMetricRatesQuery(
        {
            employeenumber: agentnumber?.toString(),
            year: inputyear,
            month: inputmonth,
            scorecardVersionId: scorecardVersion,
        },
        { skip: !agentnumber || !inputyear || !inputmonth || !scorecardVersion }
    );
    const { data: monthlyMetricHistory } = useGetMonthlyMetricHistoryQuery(
        {
            employeenumber: parseInt(agentnumber, 10),
            year: inputyear,
            month: inputmonth,
            scorecardVersionId: scorecardVersion,
        },
        {
            skip:
                !edsMetricStatusData ||
                // agentDataValue?.data?.length === 0 ||
                edsMetricStatusData?.data?.length === 0 ||
                !agentnumber,
        }
    );
    // const { data: edsDailyMetricsTableData } = useGetDailyMetricsTableDetailsQuery(
    //     {
    //         employeenumber: parseInt(agentnumber, 10),
    //         year: inputyear,
    //         month: inputmonth,
    //         scorecardVersionId: scorecardVersion,
    //     },
    //     { skip: !agentnumber }
    // );

    const { data: edsDailyMetricsData, isFetching: isDailyMetricsFetching } = useGetDailyMetricsSummaryQuery(
        {
            /* employeenumber: agentnumber, */
            employeenumber: parseInt(agentnumber, 10),
            year: inputyear,
            month: inputmonth,
            scorecardVersionId: scorecardVersion,
            scorecardRoleId: 1,
        },
        {
            skip: !edsMetricStatusData || edsMetricStatusData?.data.length === 0 || !agentnumber,
        }
    );
    const { data: edsDailyMetricsExportData } = useGetDailyMetricsSummaryExportQuery(
        {
            employeenumber: parseInt(agentnumber, 10),
            year: inputyear,
            month: inputmonth,
            scorecardVersionId: scorecardVersion,
            scorecardRoleId: 1,
        },
        {
            skip:
                !edsDailyMetricsData ||
                edsMetricStatusData?.data.length === 0 ||
                !agentnumber ||
                !scorecardVersionId,
        }
    );
    const { data: edsEmployeeMetricAllPayoutsData, isFetching: isPayoutsFetching } = useGetEmployeeMetricAllPayoutsQuery(
        {
            employeenumber: parseInt(agentnumber, 10),
            scorecardroleid: 1,
        },
        {
            skip: !edsMetricStatusData || !agentnumber,
        }
    );

    const { data: AgentNonMetricDiscussionsData } = useGetAgentNonMetricDiscussionsQuery(
        {
            employeeNumber: parseInt(agentnumber, 10),
            year: inputyear,
            month: inputmonth,
        },
        {
            skip: !agentnumber || !inputyear || !inputmonth,
        }
    );

    const { data: AgentMetricDiscussionsData } = useGetAgentMetricDiscussionsQuery(
        {
            employeeNumber: parseInt(agentnumber, 10),
            year: inputyear,
            month: inputmonth,
            scorecardVersionId: scorecardVersion,
        },
        {
            skip: !agentnumber || !inputyear || !inputmonth || !scorecardVersion,
        }
    );

    const AgentOnChange = (e: any) => {
        setAgentNumber(e.value);
    };
    type Employee = [
        {
            name: string;
            id: string;
        }
    ];
    useEffect(() => {
        if (scorecardAgentsData?.length > 0) {
            const arrayOfUsers: Employee = scorecardAgentsData?.map((item: any) => ({
                name: item?.agent_name.concat(' (', item?.agent_number, ')'),
                id: item?.agent_number,
            }));
            setListOfUsersMetrics(arrayOfUsers);
        } else {
            setListOfUsersMetrics([{ name: '', id: '' }]);
        }
    }, [scorecardAgentsData]);

    const statusData = edsMetricStatusData?.data.filter(
        (item: any) => item.scorecard_version_id === scorecardVersionId
    );
    const payoutStatusData = edsMetricPayoutStatusData?.data.filter(
        (item: any) => item.scorecard_version_id === scorecardVersionId
    );

    useEffect(() => {
        if (edsMetricStatusData?.data.length > 0) {
            // setScorecardDisable(false);
            if (window.localStorage.edsScorecardVersion) {
                setScorecardVersion(parseInt(window.localStorage.edsScorecardVersion, 10));
            } else {
                setScorecardVersion(scorecardVersionId);
            }
            setEmployeeName(
                edsMetricStatusData?.data.length > 0 ? edsMetricStatusData?.data[0].first_name : ''
            );
            setFullEmployeeName(
                edsMetricStatusData?.data.length > 0
                    ? `${edsMetricStatusData?.data[0].first_name} ${edsMetricStatusData?.data[0].last_name}`
                    : ''
            );
        } else {
            //setScorecardDisable(true);
        }
    }, [edsMetricStatusData]);

    useEffect(() => {
        if (edsDailyMetricsExportData?.data.length > 0) {
            setExportData(edsDailyMetricsExportData?.data.length > 0 ? edsDailyMetricsExportData?.data : '');
        }
    }, [edsDailyMetricsExportData]);

    useEffect(() => {
        if (eid) {
            window.localStorage.edsAgentNumber = eid;
            setAgentNumber(eid);
        }
        if (tldate) {
            const storedDate = new Date(`${tldate}`);
            if (storedDate) {
                setMonth(storedDate.getMonth() + 1);
                setYear(storedDate.getFullYear());
                window.localStorage.edsMetricDate = storedDate;
            }
        }
        if (scid) {
            window.localStorage.edsScorecardVersion = scid;
        }
    }, []);
    const isPercentageRule =
        monthlyMetricAttainmentData?.data?.length > 0 &&
        monthlyMetricAttainmentData?.data[0]?.scorecard_calculation_rule_id === 2;

    const renderMetricAttainmentSection = () => {
        if (isPercentageRule) {
            return <div />;
        }

        if (edsMonthlyMetricsData?.data?.length > 0 && payoutStatusData && payoutStatusData[0]) {
            return (
                <div className="col">
                    <MetricProgress data={edsPayoutMetrics} selectedmetrics={payoutStatusData[0]} />
                </div>
            );
        }

        return <div />;
    };
    const downloadExcel = () => {
        import('xlsx').then((XLSX: any) => {
            const lookup: any = {};
            for (let k = 0, i = 1; k < exportData.length; k++) {
                const name = exportData[k].metricname;
                if (!(name in lookup)) {
                    lookup[name] = i++;
                }
            }
            const prep = exportData.map((pro: any) => {
                return {
                    Date: pro.date,
                    name: pro.metricname,
                    Target: pro.agentmetrictarget,
                    Actual: pro.metricmeasurementforday,
                    Attainment: pro.metricattainmentindicator,
                    SupervisorID: pro.supervisorID,
                    SupervisorName: pro.supervisorName,
                    id: lookup[pro.metricname],
                };
            });
            prep.sort((a: any, b: any) => a.date - b.date);
            const headers = ['Date', 'Supervisor ID', 'Supervisor Name'].concat(
                [...Array.from(new Set(prep.map((obj: any) => obj.id)))]
                .map((id) => [`Metric${id} Name`, `Agent Target${id}`, `Actual${id}`, `Attainment Y/N`])
                .flat()
            );
            const wsdata: any = [...Array.from(new Set(prep.map((obj: any) => obj.Date)))].map((ts: any) => {
                const objByTimestamp = prep.filter((obj: any) => obj.Date === ts);
                let arr = [ts];
                if (objByTimestamp.length > 0) {
                    arr = arr.concat(objByTimestamp[0].SupervisorID, objByTimestamp[0].SupervisorName);
                }
                objByTimestamp.forEach((obj: any) => {
                    arr = arr.concat([obj.name, obj.Target, obj.Actual, obj.Attainment]);
                });
                return arr;
            });
            wsdata.unshift(headers);
            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.aoa_to_sheet(wsdata, { origin: 'A5' });
            ws['!cols'] = fitToColumn(wsdata);

            function fitToColumn(wsdata: any) {
                return wsdata[0].map((a: any, i: any) => ({
                    wch: Math.max(...wsdata.map((a2: any) => (a2[i] ? a2[i].toString().length : 0))),
                }));
            }
            XLSX.utils.sheet_add_aoa(
                ws,
                [[fullemployeeName], [`Month: ${monthNames[inputmonth]}, ${inputyear}`]],
                { origin: 'A2' }
            );
            XLSX.utils.sheet_add_aoa(ws, [['P4P Daily Metric Summary']], { origin: 'D1' });
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            saveAsExcelFile(excelBuffer, 'agents');
        });
    };
    const saveAsExcelFile = (buffer: any, fileName: any) => {
        import('file-saver').then((module) => {
            if (module && module.default) {
                const EXCEL_TYPE =
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                const EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE,
                });

                module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
            }
        });
    };

    const agentPayoutTableColumns = [
        { id: 1, name: 'Date', field: 'date', filter: true, template: 'dateBodyTemplate' },
        { id: 2, name: 'Scorecard', field: 'scorecard_name', filter: true, template: '' },
        {
            id: 3,
            name: 'Metrics Attained',
            field: 'total_metrics_attained',
            filter: true,
            template: 'metricsMetBodyTemplate',
        },
        { id: 4, name: 'Metrics Reported', field: 'total_metrics_reported', filter: true, template: '' },
        { id: 5, name: 'Eligible', field: 'eligible', filter: true, template: '' },
        { id: 6, name: 'Payout Amount', field: 'payout', filter: true, template: 'priceBodyTemplate' },
    ];
    const filterColumns = [
        'date',
        'scorecard_name',
        'total_metrics_attained',
        'total_metrics_reported',
        'eligible',
        'payout',
    ];

    const edsPayoutMetrics = useMemo(
        () => edsMonthlyMetricsData?.data?.filter((m: any) => m.is_payout_metric === true) ?? [],
        [edsMonthlyMetricsData]
    );
    const edsNonPayoutMetrics = useMemo(
        () => edsMonthlyMetricsData?.data?.filter((m: any) => m.is_payout_metric === false) ?? [],
        [edsMonthlyMetricsData]
    );

    const handleCardClick = (metricName: string, index: number) => {
            setSelectedMetricName(metricName);
            setSelectedMetricColorIndex(index);
        };
    useEffect(() => {
        if (edsMonthlyMetricsData?.data.length > 0) {
            const firstPayout = edsMonthlyMetricsData.data.find((m: any) => m.is_payout_metric === true);
            setSelectedMetricName(firstPayout?.label ?? edsMonthlyMetricsData.data[0]?.label);
            setSelectedMetricColorIndex(0);
        }
    }, [edsMonthlyMetricsData]);

    useEffect(() => {
        if (AgentNonMetricDiscussionsData?.data) {
            setAgentNonMetricDiscussionsData(AgentNonMetricDiscussionsData?.data);
        } else setAgentNonMetricDiscussionsData([]);
    }, [AgentNonMetricDiscussionsData]);

    useEffect(() => {
        if (AgentMetricDiscussionsData?.data?.length > 0) {
            const filteredData = getFilteredDataByMetricName(
                AgentMetricDiscussionsData?.data,
                selectedMetricName
            );
            setAgentMetricDiscussionsData(filteredData);
        } else setAgentMetricDiscussionsData([]);
    }, [AgentMetricDiscussionsData, selectedMetricName]);

    const filteredAgentNonMetricDiscussionsData = agentNonMetricDiscussionsData
        ? groupNonMetricDataByMonth(agentNonMetricDiscussionsData)
        : [];
    const filteredAgentMetricDiscussionsData = agentMetricDiscussionsData
        ? groupMetricDataByMonth(agentMetricDiscussionsData)
        : [];

    // Main content is driven by 3 queries (status/monthly/daily) which are all skipped until an
    // agent is picked. Any one of them fetching (including the very first load) keeps the
    // skeleton up rather than letting the empty state flash while data is still on its way.
    const isMainContentLoading =
        !!agentnumber && (isMetricStatusFetching || isMonthlyMetricsFetching || isDailyMetricsFetching);

    // Secondary sections below (greeting card, attainment/payout row) previously rendered
    // nothing at all while their queries were in flight, which reads as a layout jump once the
    // real content pops in. A lightweight shimmer bar keeps the layout stable instead.
    const isAttainmentSectionLoading =
        !!agentnumber && (isMonthlyAttainmentFetching || isPayoutStatusFetching || isPayoutRatesFetching);

    const renderGreetingCard = () => {
        if (isMetricStatusFetching) {
            return (
                <div className="row mt-4">
                    <div className="col-12">
                        <div className="skeleton-line skeleton-shimmer" style={{ height: '80px', width: '100%', borderRadius: '8px' }} />
                    </div>
                </div>
            );
        }

        if (statusData?.length > 0) {
            return (
                <div className="row mt-4">
                    <div className="col-12">
                        <MetricGreetingCard
                            employeeName={employeeName}
                            totalMetricsAttained={statusData[0].total_metrics_attained}
                            totalMetricsReported={statusData[0].total_metrics_reported}
                            totalMetricsTargeted={statusData[0].total_metrics_targeted}
                            scorecardCalculationRuleId={edsMonthlyMetricsData?.data[0]?.scorecard_calculation_rule_id}
                        />
                    </div>
                </div>
            );
        }

        return '';
    };

    const renderMainContent = () => {
        if (isMainContentLoading) {
            return (
                <div className="p-3">
                    <MetricCardsSkeletonLoader />
                </div>
            );
        }

        if (edsDailyMetricsData?.data.length > 0) {
            return (
                <>
                    <GradientDefs />
                    <div className="card shadow row ms-3 me-3 mt-4">
                        <div className="p-3">
                            {edsNonPayoutMetrics.length > 0 && (
                                <div className="metrics-tab-switcher">
                                    <button
                                        className={`metrics-tab ${activeTab === 'standard' ? 'metrics-tab--active' : ''}`}
                                        onClick={() => setActiveTab('standard')}
                                        type="button"
                                    >
                                        <img src={standardMetricsIcon} alt="Standard Metrics" style={{ width: '16px', height: '16px' }} />
                                        Standard Metrics
                                    </button>
                                    <button
                                        className={`metrics-tab ${activeTab === 'additional' ? 'metrics-tab--active' : ''}`}
                                        onClick={() => setActiveTab('additional')}
                                        type="button"
                                    >
                                        <img src={additionalMetricsIcon} alt="Additional Metrics" style={{ width: '16px', height: '16px' }} />
                                        Additional Metrics (Non Payout)
                                    </button>
                                </div>
                            )}
                            <div className="metrics-tab-content">
                                {activeTab === 'standard' && (
                                    <StandardMetricsPanel
                                        metrics={edsPayoutMetrics}
                                        dailyMetricsData={edsDailyMetricsData}
                                        monthlyMetricHistory={monthlyMetricHistory}
                                        scorecardVersionId={scorecardVersion}
                                        employeeNumber={agentnumber ?? ''}
                                        fromMetricDashboard
                                        selectedMetricName={selectedMetricName}
                                        selectedMetricColorIndex={selectedMetricColorIndex}
                                        onCardClick={handleCardClick}
                                    >
                                        {location.pathname === MANAGERDASHBOARD && (
                                            <AgentDiscussionsPlot
                                                nonMetricDiscussionsData={filteredAgentNonMetricDiscussionsData}
                                                metricDiscussionsData={filteredAgentMetricDiscussionsData}
                                                recieverId={agentnumber}
                                                receiverName={employeeName}
                                                inputYear={inputyear}
                                                inputMonth={inputmonth}
                                                metricIndex={selectedMetricColorIndex}
                                                metricOmitted={
                                                    edsDailyMetricsData?.data?.find((m: any) => m.label === selectedMetricName)?.metric_omitted || false
                                                }
                                            />
                                        )}
                                    </StandardMetricsPanel>
                                )}
                                {activeTab === 'additional' && (
                                    <NonPayoutMetricsPanel
                                        metrics={edsNonPayoutMetrics}
                                        dailyMetricsData={edsDailyMetricsData}
                                        monthlyMetricHistory={monthlyMetricHistory}
                                        scorecardVersionId={scorecardVersion}
                                        employeeNumber={agentnumber ?? ''}
                                    />
                                )}
                            </div>
                        </div>
                    </div>

                    {edsDailyMetricsData?.data.length > 0 && (
                        <div className="col-12 text-end exportexcel float-end mt-4 mb-3">
                            <Button
                                type="button"
                                icon="pi pi-file-excel me-2"
                                onClick={downloadExcel}
                                className="btn-export me-4 float-end"
                                data-pr-tooltip="XLS"
                            >
                                Export as Excel
                            </Button>
                        </div>
                    )}
                </>
            );
        }

        return (
            <div className="metric-dashboard-empty">
                <div className="metric-dashboard-empty__illustration">
                    <SadFolderIllustration />
                </div>
                <div className="metric-dashboard-empty__divider" />
                <p className="metric-dashboard-empty__title">
                    {agentnumber
                        ? 'No Results found for the Performance Period.'
                        : 'Select an agent above to view their metrics.'}
                </p>
            </div>
        );
    };

    const renderPayoutsPanel = () => {
        if (isPayoutsFetching) {
            return (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '160px' }}>
                    <ProgressSpinner style={{ width: '48px', height: '48px' }} strokeWidth="4" animationDuration="0.8s" />
                </div>
            );
        }

        if (edsEmployeeMetricAllPayoutsData?.data.length > 0) {
            return (
                <MetricPayoutTable
                    data={edsEmployeeMetricAllPayoutsData?.data}
                    scorecardroleid={1}
                    columns={agentPayoutTableColumns}
                    uniqueKey="key"
                    filterColumns={filterColumns}
                />
            );
        }

        return (
            <div className="metric-dashboard-empty">
                <div className="metric-dashboard-empty__illustration">
                    <SadFolderIllustration />
                </div>
                <div className="metric-dashboard-empty__divider" />
                <p className="metric-dashboard-empty__title">No Results found for Payouts.</p>
            </div>
        );
    };

    return (
        <>
            <Dropdown
                disabled={agentDisable}
                value={agentnumber}
                onChange={AgentOnChange}
                options={listOfUsersMetrics}
                optionValue={'id'}
                optionLabel={'name'}
                placeholder={'Select Agent'}
                filter
                className="custom-dropdown mt-3 ms-3"
            />
            {renderGreetingCard()}
            {renderMainContent()}
            <div style={{ display: statusData?.length > 0 ? '' : 'none' }} />
            {/* <div className="row row-cols-1 row-cols-md-2 g-2 ms-3 me-3">
                {edsMonthlyMetricsData?.data && payoutStatusData?.length > 0 ? (
                    <div className="col">
                        <MetricProgress
                            data={edsPayoutMetrics}
                            selectedmetrics={payoutStatusData[0]}
                        />
                    </div>
                ) : (
                    <div />
                )}
                {edsMetricPayoutStatusData?.data.length > 0 && payoutStatusData[0] ? (
                    <div className="col">
                        <PayoutCalculator empMetricData={payoutStatusData[0]} />
                    </div>
                ) : (
                    <div />
                )}
            </div> */}
            {isAttainmentSectionLoading ? (
                <div className="row row-cols-1 row-cols-md-2 g-2 ms-3 me-3">
                    <div className="col">
                        <div className="skeleton-line skeleton-shimmer" style={{ height: '140px', width: '100%', borderRadius: '8px' }} />
                    </div>
                    <div className="col">
                        <div className="skeleton-line skeleton-shimmer" style={{ height: '140px', width: '100%', borderRadius: '8px' }} />
                    </div>
                </div>
            ) : (
                <>
                    {isPercentageRule && payoutStatusData?.length > 0 && payoutStatusData[0] && (
                        <div className="row ms-3 me-3">
                            <div className="col-12">
                                <MetricAttainmentPayoutCalculator
                                    data={monthlyMetricAttainmentData?.data}
                                    payoutRates={empPayoutLevelMetricRatesData?.data}
                                    resultData={payoutStatusData[0]}
                                />
                            </div>
                        </div>
                    )}
                    <div className="row row-cols-1 row-cols-md-2 g-2 ms-3 me-3">
                        {renderMetricAttainmentSection()}
                        {payoutStatusData?.length > 0 && payoutStatusData[0] && payoutStatusData[0].scorecard_calculation_rule_id === 1 && (
                            <div className="col">
                                <PayoutCalculator empMetricData={payoutStatusData[0]} />
                            </div>
                        )}
                    </div>
                </>
            )}
            <br />

            <Panel
                header="All Metrics"
                toggleable
                className="card mt-5 ms-4 me-4 shadow bg-body rounded border-0"
            >
                <div className="row mt-3 me-3">
                    {/* {edsDailyMetricsTableData?.data.length > 0 ? ( */}
                        <MyDailyMetricsTable
                            // data={edsDailyMetricsTableData}
                            employeenumber={agentnumber}
                            year={inputyear}
                            month={inputmonth}
                            scorecardVersionId={scorecardVersion}
                            monthlyMetricsData={edsMonthlyMetricsData}
                        />
                    {/* ) : (
                        <div>No Results Found</div>
                    )} */}
                </div>
            </Panel>

            <Panel
                header="Payouts"
                toggleable
                className="card mt-5 ms-4 me-4 shadow bg-body rounded border-0"
            >
                <div className="payoutTitle"> All Payouts</div>
                {renderPayoutsPanel()}
            </Panel>
        </>
    );
};